module.exports = __webpack_public_path__ + "static/video-cover-db2df4cbe1df55b9fde022e927e231cf.jpg";